import React from "react";
import styled from "styled-components";
import { parseInline } from "../components/result-document/parseBody";

/**
 * 결과 페이지 보조 카드: 두 번째 묶음(예: '환상')에서 가장 높은 습관의 설명.
 * body 는 빈 줄로 문단을 나누고, ==형광펜== / **굵게** 를 쓸 수 있습니다.
 */
export const InsightCard = ({ label, insight }) => {
  if (!insight) return null;
  const paragraphs = (insight.body || "").trim().split(/\n\s*\n/);

  return (
    <Card>
      <Label>{label}</Label>
      <Title>{insight.type}</Title>
      {insight.subtitle && <Sub>{insight.subtitle}</Sub>}
      {paragraphs.map((p, i) => (
        <P key={i}>
          {p.split("\n").map((line, j) => (
            <React.Fragment key={j}>
              {j > 0 && <br />}
              {parseInline(line).map((part, k) =>
                part.mark ? (
                  <Mark key={k}>{part.text}</Mark>
                ) : part.bold ? (
                  <strong key={k}>{part.text}</strong>
                ) : (
                  <React.Fragment key={k}>{part.text}</React.Fragment>
                )
              )}
            </React.Fragment>
          ))}
        </P>
      ))}
    </Card>
  );
};

const Card = styled.section`
  width: 100%;
  margin-top: 8px;
  padding: 24px 22px 20px;
  border: 1px solid #e6e6e6;
  border-radius: 16px;
  font-family: "Gyeonggi Batang", "GyeonggiBatang", serif;
  color: #171515;
  background: #fffdf8;
`;

const Label = styled.div`
  font-size: 13px;
  letter-spacing: 0.08em;
  color: #9a7b4f;
`;

const Title = styled.h3`
  margin-top: 6px;
  font-size: 21px;
  font-weight: 700;
`;

const Sub = styled.p`
  margin-top: 8px;
  font-size: 14.5px;
  line-height: 1.6;
  color: #666;
  white-space: pre-line;
`;

const P = styled.p`
  margin-top: 14px;
  font-size: 15.5px;
  line-height: 1.75;
  word-break: keep-all;
  overflow-wrap: anywhere;
`;

const Mark = styled.span`
  background: linear-gradient(transparent 12%, #fadeac 12%, #fadeac 92%, transparent 92%);
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
`;
